<div class="w-full h-full inline-block align-middle">
    <div class="flex justify-center w-full md:mt-11 pb-6">
        <img src="assets/icons/Icons/other-payment-options/OTT-Voucher.png" alt="ott logo">
    </div>
    <router-outlet></router-outlet>
</div>
